module.exports = __webpack_public_path__ + "img/0x663a07a2648296f1A3C02EE86A126fE1407888E5.f6c5fc22.png";